import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './FeedbackSection.css';
import LikeDislikeButtons from '../../../component/likeDislikeButtons/LikeDislikeButtons';

interface FeedbackSectionProps {
    videoId: number;
    onRate?: (videoId: number, rating: 'like' | 'dislike' | null) => void;
}

function FeedbackSection({videoId, onRate}: FeedbackSectionProps) {
    const {t} = useTranslation('layout');
    const [rating, setRating] = useState<'like' | 'dislike' | null>(null);

    const handleRate = (newRating: 'like' | 'dislike') => {
        const finalRating = rating === newRating ? null : newRating;
        setRating(finalRating);
        onRate?.(videoId, finalRating);
    };

    return (
        <css.feedbackSection>
            <css.feedbackText>
                <strong>{t('wowYouMadeIt')}</strong>
                <span>{t('didWeHelp')}</span>
            </css.feedbackText>
            <LikeDislikeButtons
                value={rating}
                onChange={handleRate}
            />
        </css.feedbackSection>
    );
}

export default FeedbackSection;
